import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

function CourierAccordionSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg border border-border bg-card">
      <div className="border-b border-border bg-muted/30 px-4 py-3">
        <div className="flex items-center gap-3">
          <Skeleton className="h-10 w-10 rounded bg-hover-press" />
          <div className="space-y-2">
            <Skeleton className="h-5 w-36 rounded-full bg-hover-press" />
            <Skeleton className="h-3 w-24 rounded-full bg-hover-press" />
          </div>
        </div>
      </div>

      <div className="space-y-3 px-4 py-4">
        {[1, 2].map((index) => (
          <div key={index} className="rounded-lg border border-border p-3">
            <div className="mb-3 flex items-center justify-between">
              <Skeleton className="h-5 w-40 rounded-full bg-hover-press" />
              <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-5/6 rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-2/3 rounded-full bg-hover-press" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export const CoverageZonesSkeleton = () => {
  return (
    <div className="w-full pb-6" data-testid="coverage-zones-skeleton">
      <div className="flex justify-between gap-4">
        <div className="min-w-0 space-y-2">
          <Skeleton className="h-8 w-56 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-72 max-w-full rounded-full bg-hover-press" />
        </div>
        <div className="flex shrink-0 items-center">
          <Skeleton className="h-10 w-36 rounded-full bg-hover-press" />
        </div>
      </div>

      <div className="mt-8">
        <Skeleton className="h-10 w-full max-w-md rounded-md bg-hover-press" />

        <div className="mt-6 space-y-4">
          {[1, 2, 3].map((index) => (
            <CourierAccordionSkeleton key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};
